import type { Toast } from '../net';

interface Props {
  toasts: Toast[];
  onDismiss: (id: number) => void;
}

const ICON: Record<Toast['kind'], string> = {
  info: 'ℹ️',
  error: '⚠️',
  penalty: '💥',
  success: '🎉',
};

export function Toasts({ toasts, onDismiss }: Props) {
  if (!toasts.length) return null;
  return (
    <div className="toasts" role="log" aria-live="polite">
      {toasts.map((toast) => (
        <button
          key={toast.id}
          type="button"
          className={`toast toast--${toast.kind}`}
          onClick={() => onDismiss(toast.id)}
        >
          <span aria-hidden="true">{ICON[toast.kind]}</span>
          <span>{toast.text}</span>
        </button>
      ))}
    </div>
  );
}
